import { useEffect } from 'react';
import { House, Search, Signpost } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import EmptyState from '../components/EmptyState';
import { useTranslations } from '../translations';
import './NotFoundPage.css';

interface NotFoundPageProps {
  isLoggedIn: boolean;
  isAdmin?: boolean;
  onNavigateToLogin: () => void;
  onNavigateToRegister: () => void;
  onNavigateToHome: () => void;
  onNavigateToSearch: () => void;
  onLogout: () => void;
  onNavigateToProfile?: () => void;
  onNavigateToLocations?: () => void;
  onNavigateToMyAnnouncements?: () => void;
  onNavigateToSettings?: () => void;
  onNavigateToCreateProduct?: () => void;
  onNavigateToMessages?: (productId?: string | null) => void;
  onNavigateToAdministration?: () => void;
  onNavigateToTerms?: () => void;
  onNavigateToPrivacy?: () => void;
  onNavigateToCookies?: () => void;
  onNavigateToAbout?: () => void;
  onNavigateToContact?: () => void;
}

const NotFoundPage = ({
  isLoggedIn,
  isAdmin,
  onNavigateToLogin,
  onNavigateToRegister,
  onNavigateToHome,
  onNavigateToSearch,
  onLogout,
  onNavigateToProfile,
  onNavigateToLocations,
  onNavigateToMyAnnouncements,
  onNavigateToSettings,
  onNavigateToCreateProduct,
  onNavigateToMessages,
  onNavigateToAdministration,
  onNavigateToTerms,
  onNavigateToPrivacy,
  onNavigateToCookies,
  onNavigateToAbout,
  onNavigateToContact
}: NotFoundPageProps) => {
  const t = useTranslations();

  useEffect(() => {
    const previousTitle = document.title;
    document.title = `${t.notFound.title} | roade.ro`;
    return () => {
      document.title = previousTitle;
    };
  }, [t.notFound.title]);

  return (
    <div className="not-found-page">
      <Header
        isLoggedIn={isLoggedIn}
        isAdmin={isAdmin}
        onNavigateToLogin={onNavigateToLogin}
        onNavigateToRegister={onNavigateToRegister}
        onNavigateToHome={onNavigateToHome}
        onLogout={onLogout}
        onProfileClick={onNavigateToProfile}
        onLocationsClick={onNavigateToLocations}
        onMessagesClick={onNavigateToMessages}
        onAnnouncementsClick={onNavigateToMyAnnouncements}
        onSettingsClick={onNavigateToSettings}
        onAdministrationClick={onNavigateToAdministration}
        onNavigateToCreateProduct={onNavigateToCreateProduct}
      />

      <main className="not-found-content">
        <EmptyState
          eyebrow={t.notFound.code}
          icon={<Signpost />}
          title={t.notFound.title}
          description={t.notFound.description}
        >
          <button className="app-empty-state-primary" type="button" onClick={onNavigateToHome}>
            <House size={17} aria-hidden="true" />
            {t.notFound.homeAction}
          </button>
          <button className="app-empty-state-secondary" type="button" onClick={onNavigateToSearch}>
            <Search size={17} aria-hidden="true" />
            {t.notFound.searchAction}
          </button>
        </EmptyState>
      </main>

      <Footer
        onNavigateToTerms={onNavigateToTerms}
        onNavigateToPrivacy={onNavigateToPrivacy}
        onNavigateToCookies={onNavigateToCookies}
        onNavigateToAbout={onNavigateToAbout}
        onNavigateToContact={onNavigateToContact}
      />
    </div>
  );
};

export default NotFoundPage;
